import React from "react";

const Wifi = () => {
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      data-bbox="9.087 39.3 182.438 121.4"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="9.087 39.3 182.438 121.4"
      role="img"
      className="content-card__svg"
    >
      <g>
        <ellipse cx="100.3" cy="154.5" rx="6.2" ry="6.2"></ellipse>
        <path
          d="M190.7,77c-23.9-24.3-55.8-37.7-89.8-37.7c-34.6,0-67,13.9-91,39.1c-1.1,1.1-1.1,3,0.1,4.1c0.6,0.5,1.3,0.8,2,0.8
		c0.8,0,1.5-0.3,2.1-0.9c22.9-24,53.8-37.3,86.8-37.3c32.5,0,62.9,12.8,85.7,36c1.1,1.1,2.9,1.1,4.1,0C191.8,80,191.8,78.2,190.7,77
		z"
        ></path>
        <path
          d="M100.9,74.5c-25.3,0-48.8,10.2-66.2,28.8c-1.1,1.2-1,3,0.1,4.1c0.6,0.5,1.3,0.8,2,0.8c0.8,0,1.5-0.3,2.1-0.9
		c16.3-17.4,38.3-27,62-27c23.1,0,44.7,9.1,60.8,25.7c1.1,1.1,2.9,1.2,4.1,0.1c1.1-1.1,1.2-2.9,0.1-4.1
		C148.6,84.2,125.6,74.5,100.9,74.5z"
        ></path>
        <path
          d="M100.3,110.9c-15,0-29.6,6.4-39.8,17.5c-1.1,1.2-1,3,0.2,4.1c1.2,1.1,3,1,4.1-0.2c9.3-10.1,22-15.6,35.6-15.6
		c13.6,0,26.3,5.5,35.6,15.6c0.6,0.6,1.3,0.9,2.1,0.9c0.7,0,1.4-0.3,2-0.8c1.2-1.1,1.2-2.9,0.2-4.1
		C129.9,117.2,115.4,110.9,100.3,110.9z"
        ></path>
      </g>
    </svg>
  );
};

export default Wifi;
